import type { UserConfigContextValue, UserTableColumnFromApi } from "./types";
import type { UserFieldConfig } from "@hooks/use-config/user";
import { TableCellInputType } from "@components/data-table/types";

const userFieldInputType = (type: string): TableCellInputType => {
  if (type === "select") return TableCellInputType.Select;
  if (type === "date" || type === "datetime" || type === "time") return TableCellInputType.Date;
  if (type === "datetime") return TableCellInputType.DateTime;
  return TableCellInputType.Text;
};

export const initialUserConfigContextValue: UserConfigContextValue = {
  loading: true,
  error: null,
  config: {} as any,
  tableColumns: [],
};

/**
 * Build table columns from a dynamic field config returned by GET /site-users/config.
 * Only fields with display: true are included.
 */
export const getTableColumnsFromFields = (
  fields: Record<string, UserFieldConfig>
): UserTableColumnFromApi[] => {
  return Object.values(fields)
    .filter((field) => field.display && field.id !== "wp_user_id")
    .sort((a, b) => (a.order ?? Infinity) - (b.order ?? Infinity))
    .map((field) => ({
      id: field.id,
      label: field.name,
      getValue: (user) => (user as any)[field.id] ?? "—",
      inputType: userFieldInputType(field.type),
      clone: field.clone,
      options: field.options.length
        ? Object.fromEntries(field.options.map((o) => [o.value, o.label]))
        : undefined,
    }));
};


